export enum ElectricQueryKeys {
  GET_ELECTRIC_BILLS = 'GET_ELECTRIC_BILLS',
  GET_ELECTRIC_BILLS_DETAILS = 'GET_ELECTRIC_BILLS_DETAILS',
  GET_ELECTRIC_TRANSACTIONS = 'GET_ELECTRIC_TRANSACTIONS',
  EXPORT_ELECTRIC_TRANSACTIONS = 'EXPORT_ELECTRIC_TRANSACTIONS',
}
